'use es6';

import http from 'hub-http/clients/apiClient';
/*
 * GET    /cos-rendering/v1/hubldoc
 */

export function fetch() {
  return http.get('cos-rendering/v1/hubldoc');
}